import script from "./PopupPreviewProf.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupPreviewProf.vue?vue&type=script&setup=true&lang=js"

import "./PopupPreviewProf.vue?vue&type=style&index=0&id=10cc84e8&lang=scss"

const __exports__ = script;

export default __exports__